import { loadTextureFromBuffer } from "../../../../api/threed";
import { RobotSlamMap } from "../../../../models/Deployment";
import { AgentEvents } from "../../agents/BaseAgent";
import { RobotAgent } from "../RobotAgent";
import { RTVisualizer } from "./RTVisualizer";
import * as THREE from "three";
export class CostmapVisualizer extends RTVisualizer {
  public geometry = new THREE.PlaneGeometry(1, 1);
  public material = new THREE.MeshPhongMaterial({
    // color: 0x858585,
    side: THREE.DoubleSide,
    opacity: 0.5,
    transparent: true,
  });
  public plane = new THREE.Mesh(this.geometry, this.material);
  private disappearTimeout: any;
  constructor(agent: RobotAgent) {
    super(agent);
    this.plane.name = 'costmapPlane';
    this.plane.visible = false;
    const previous = agent.visual.obj.getObjectByName('costmapPlane');
    previous?.removeFromParent();
    agent.visual.obj.add(this.plane);
    this.plane.position.z = 0.06;
    this.agent.on(AgentEvents.StateChange, (dgram: Partial<RobotAgent>) => {
      if (dgram.costmapData) {
        this.updateCostmap(dgram.costmapData).catch(console.error);
      }
    });
  }

  private async updateCostmap(map: RobotSlamMap) {
    if (!this.active) {
      return;
    }
    if (this.disappearTimeout) {
      clearTimeout(this.disappearTimeout);
      this.disappearTimeout = null;
    }
    const { width, height, texture } = await loadTextureFromBuffer(map.data!);
    const scaledWidth = width * map.resolution;
    const scaledHeight = height * map.resolution;
    this.geometry.dispose();
    this.geometry = new THREE.PlaneGeometry(scaledWidth, scaledHeight);
    this.plane.geometry = this.geometry;
    this.material.map = texture;
    this.plane.rotation.set(0, 0, -this.agent.visual.obj.rotation.z);
    this.plane.visible = true;
    this.disappearTimeout = setTimeout(() => this.plane.visible = false, 5000);
  }
}